import React from 'react';
import { AlertTriangle, CheckCircle, XCircle, AlertCircle } from 'lucide-react';

interface Risk {
  id: string;
  category: string;
  description: string;
  impact: 'high' | 'medium' | 'low';
  status: 'identified' | 'mitigated' | 'monitoring';
}

export default function RiskAssessment() {
  const risks: Risk[] = [
    {
      id: '1',
      category: 'Financial',
      description: 'Potential overvaluation of target company assets',
      impact: 'high',
      status: 'monitoring'
    },
    {
      id: '2',
      category: 'Legal',
      description: 'Pending litigation in target company',
      impact: 'high',
      status: 'identified'
    },
    {
      id: '3',
      category: 'Operational',
      description: 'Integration challenges with existing systems',
      impact: 'medium',
      status: 'mitigated'
    }
  ];

  const getImpactIcon = (impact: string) => {
    switch (impact) {
      case 'high':
        return <AlertTriangle className="w-5 h-5 text-red-500" />;
      case 'medium':
        return <AlertCircle className="w-5 h-5 text-yellow-500" />;
      case 'low':
        return <CheckCircle className="w-5 h-5 text-green-500" />;
      default:
        return null;
    }
  };

  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'identified':
        return <span className="px-2 py-1 text-xs font-medium rounded-full bg-red-100 text-red-800">Identified</span>;
      case 'mitigated':
        return <span className="px-2 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800">Mitigated</span>;
      case 'monitoring':
        return <span className="px-2 py-1 text-xs font-medium rounded-full bg-yellow-100 text-yellow-800">Monitoring</span>;
      default:
        return null;
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm">
      <div className="px-6 py-4 border-b border-gray-200">
        <h3 className="text-lg font-medium text-gray-900">Risk Assessment</h3>
      </div>

      <div className="divide-y divide-gray-200">
        {risks.map((risk) => (
          <div key={risk.id} className="px-6 py-4">
            <div className="flex items-start">
              <div className="flex-shrink-0 mt-1">
                {getImpactIcon(risk.impact)}
              </div>
              <div className="ml-3 flex-1">
                <div className="flex items-center justify-between">
                  <p className="text-sm font-medium text-gray-900">
                    {risk.category}
                  </p>
                  {getStatusBadge(risk.status)}
                </div>
                <p className="mt-1 text-sm text-gray-600">
                  {risk.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}